"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextComponent = _styledComponents.default.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-family: ", ";\n  text-align: ", ";\n  margin: ", ";\n  padding: ", ";\n  display: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  border: ", ";\n  .anticon {\n    margin-right: 9px;\n  }\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.lineheight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.textalign;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.display;
}, function (props) {
  return props.alignitems;
}, function (props) {
  return props.justifycontent;
}, function (props) {
  return props.border;
});

function Text(props) {
  var color = props.color,
      fontSize = props.fontSize,
      fontWeight = props.fontWeight,
      lineheight = props.lineheight,
      textalign = props.textalign,
      margin = props.margin,
      padding = props.padding,
      display = props.display,
      border = props.border,
      alignitems = props.alignitems,
      justifycontent = props.justifycontent,
      className = props.className,
      width = props.width,
      label = props.label,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? null : _props$icon;
  return /*#__PURE__*/_react.default.createElement(TextComponent, {
    color: color,
    fontSize: fontSize,
    lineheight: lineheight,
    fontWeight: fontWeight,
    textalign: textalign,
    margin: margin,
    padding: padding,
    display: display,
    alignitems: alignitems,
    justifycontent: justifycontent,
    className: className,
    border: border,
    width: width
  }, icon ? icon : null, icon ? " " + label : label);
}

var _default = Text;
exports.default = _default;